export default __webpack_public_path__ + "static/media/road_img_1_1.22ebe8f4.jpg";